import React, { Component } from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import { CLOUDINARY_SHARE } from "../../helpers/cloudinaryConstants";

class BusinessItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id;
  }

  render() {
    const { gnObject } = this.props;
    return (
      <Col xs="12" md="6">
        <Card>
          <CardHeader>Business</CardHeader>
          <CardBody>
            <h4>Business: {gnObject.name}</h4>
            <h5>ID: {gnObject.id}</h5>
            {!gnObject.avatar.isDefault && (
              <img
                style={{ width: "50%" }}
                src={`${CLOUDINARY_SHARE}/${
                  gnObject.avatar.image.cloudinaryId
                }`}
              />
            )}
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    );
  }
}

export default BusinessItem;



// WEBPACK FOOTER //
// ./src/views/Components/BusinessItem.js